exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".radio-form-control{width:100%;margin-top:6px !important;margin-bottom:8px !important}.radio-form-control .radio-form-label{text-align:left;transform:translate(0, 1.5px) scale(1);transform-origin:top left}.radio-form-control .radio-group .radio-form-control-label:first-child{margin-left:0}.radio-form-control .radio-group .radio-form-control-label .radio-input{padding-top:5px;padding-bottom:5px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js?{"ident":"postcss","plugins":[null,null]}!./src/components/RadioInput/style.scss
// module id = 1519
// module chunks = 0